import { render, staticRenderFns } from "./DepartmentFilter.vue?vue&type=template&id=3030dda9&"
import script from "./DepartmentFilter.vue?vue&type=script&lang=js&"
export * from "./DepartmentFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports